var React = require('react');

function IcMailModule (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0V0z","key":0}),React.createElement("path",{"fill":"#97a1a9","d":"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 14H5c-.55 0-1-.45-1-1V8l6.94 4.34c.65.41 1.47.41 2.12 0L20 8v9c0 .55-.45 1-1 1zm-7-7L4 6h16l-8 5z","key":1})]);
}

IcMailModule.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcMailModule;

IcMailModule.default = IcMailModule;
